/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';

/**
 * 
 * @export
 * @interface PayCycle
 */
export interface PayCycle {
    /**
     * 
     * @type {number}
     * @memberof PayCycle
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof PayCycle
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof PayCycle
     */
    frequency: PayCycleFrequencyEnum;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof PayCycle
     */
    startsOn: ShiftiePlainDate;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof PayCycle
     */
    endsOn: ShiftiePlainDate | null;
}

/**
* @export
* @enum {string}
*/
export enum PayCycleFrequencyEnum {
    FourWeekly = 'FourWeekly',
    Monthly = 'Monthly',
    TwoWeekly = 'TwoWeekly',
    Weekly = 'Weekly'
}


/**
 * Check if a given object implements the PayCycle interface.
 */
export function instanceOfPayCycle(value: object): value is PayCycle {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('frequency' in value) || value['frequency'] === undefined) return false;
    if (!('startsOn' in value) || value['startsOn'] === undefined) return false;
    if (!('endsOn' in value) || value['endsOn'] === undefined) return false;
    return true;
}

export function PayCycleFromJSON(json: any): PayCycle {
    return PayCycleFromJSONTyped(json, false);
}

export function PayCycleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayCycle {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'frequency': json['frequency'],
        'startsOn': ShiftiePlainDateFromJSON(json['startsOn']),
        'endsOn': ShiftiePlainDateFromJSON(json['endsOn']),
    };
}

  export function PayCycleToJSON(json: any): PayCycle {
      return PayCycleToJSONTyped(json, false);
  }

  export function PayCycleToJSONTyped(value?: PayCycle | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'frequency': value['frequency'],
        'startsOn': ShiftiePlainDateToJSON(value['startsOn']),
        'endsOn': ShiftiePlainDateToJSON(value['endsOn']),
    };
}

